<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t("$vuetify.CIRCUITOS_POOL_VIRTUAL", pool.nome)}}
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="max-height: 400px; overflow-y: auto">
        <v-list dense v-if="circuits && circuits.length > 0" class="mt-3">
          <v-list-item v-for="circuit in circuits" :key="circuit.id">
            <!-- Nome da designação -->
            <v-list-item-content>
              <v-list-item-title>
                {{ circuit.designacaoTpz }}
              </v-list-item-title>
            </v-list-item-content>

            <v-spacer></v-spacer>

            <!-- Chip de consumo -->
            <v-chip small color="blue lighten-4" text-color="blue darken-3" label>
              {{ formatGB(circuit.consumo) }}
            </v-chip>
          </v-list-item>
        </v-list>

        <WarningPanel
          class="mt-4 pt-12 ml-n0"
          :mobile="true"
          :message="$vuetify.lang.t('$vuetify.NENHUM_CIRCUITO_ASSOCIADO')"
          v-show="circuits && circuits.length == 0"
          :small="true"
        >
        </WarningPanel>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
         <v-btn
          color="blue darken-2"
          text
          @click="close"
        >
          {{ $vuetify.lang.t("$vuetify.FECHAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WarningPanel from "@/components/panels/WarningPanel.vue";

export default {
  components: {
    WarningPanel,
  },
  data() {
    return {
    };
  },

  props: {
    pool: {
      type: Object,
      required: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    close: Function,
    circuits: Array,
  },

  methods: {
    formatGB(value) {
      return value? value.split("/")[0]: "0 GB";
    },
  },
};
</script>